import { PartialTranslation } from '../translations';

export const pa: PartialTranslation = {
  newChat: 'ਨਵੀਂ ਗੱਲਬਾਤ',
  search: 'ਖੋਜ',
  user: 'ਉਪਭੋਗਤਾ',
  settings: 'ਸੈਟਿੰਗਾਂ',
  language: 'ਭਾਸ਼ਾ',
  getHelp: 'ਮਦਦ ਲਓ',
  viewAllPlans: 'ਸਾਰੀਆਂ ਯੋਜਨਾਵਾਂ ਦੇਖੋ',
  learnMore: 'ਹੋਰ ਜਾਣੋ',
  logOut: 'ਲਾਗ ਆਊਟ',
  chooseLanguage: 'ਭਾਸ਼ਾ ਚੁਣੋ',
  chooseYourPreferredLanguage: 'ਆਪਣੀ ਪਸੰਦੀਦਾ ਭਾਸ਼ਾ ਚੁਣੋ',
  searchLanguages: 'ਭਾਸ਼ਾਵਾਂ ਖੋਜੋ...',
  autoDetect: 'ਆਟੋਮੈਟਿਕ ਖੋਜ',
  noLanguagesFound: 'ਕੋਈ ਭਾਸ਼ਾ ਨਹੀਂ ਮਿਲੀ',
  askAnything: 'ਕੁਝ ਵੀ ਪੁੱਛੋ',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'ਨਿੱਜੀ',
  freePlan: 'ਮੁਫਤ ਯੋਜਨਾ',
  current: 'ਮੌਜੂਦਾ',
  close: 'ਬੰਦ ਕਰੋ',
  archive: 'ਆਰਕਾਈਵ',
  delete: 'ਮਿਟਾਓ',
  confirmDelete: 'ਕੀ ਤੁਸੀਂ ਇਸ ਗੱਲਬਾਤ ਨੂੰ ਮਿਟਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ?',
  confirmArchive: 'ਕੀ ਤੁਸੀਂ ਇਸ ਗੱਲਬਾਤ ਨੂੰ ਆਰਕਾਈਵ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?',
  deleteCannotUndo: 'ਇਸ ਕਿਰਿਆ ਨੂੰ ਵਾਪਸ ਨਹੀਂ ਕੀਤਾ ਜਾ ਸਕਦਾ।',
  archiveCanFind: 'ਆਰਕਾਈਵ ਕਰਨ ਤੋਂ ਬਾਅਦ ਤੁਸੀਂ ਇਸਨੂੰ ਆਰਕਾਈਵ ਸੂਚੀ ਵਿੱਚ ਲੱਭ ਸਕਦੇ ਹੋ।',
  
  // 资源面板
  resources: 'ਸਰੋਤ',
  addResource: 'ਸਰੋਤ ਸ਼ਾਮਲ ਕਰੋ',
  deleteResource: 'ਸਰੋਤ ਮਿਟਾਓ',
  noMatchingResourcesFound: 'ਕੋਈ ਮੇਲ ਖਾਂਦੇ ਸਰੋਤ ਨਹੀਂ ਮਿਲੇ',
  noResourcesAvailable: 'ਕੋਈ ਸਰੋਤ ਉਪਲਬਧ ਨਹੀਂ',
  hideResources: 'ਸਰੋਤ ਲੁਕਾਓ',
  showResources: 'ਸਰੋਤ ਦਿਖਾਓ',
  
  // 聊天输入框
  typeMessage: 'ਸੰਦੇਸ਼ ਲਿਖੋ...',
  thinkingOptions: 'ਸੋਚ ਵਿਕਲਪ',
  deleteFile: 'ਫਾਈਲ ਮਿਟਾਓ',
  clearSelection: 'ਚੋਣ ਸਾਫ਼ ਕਰੋ',
  addAttachment: 'ਅਟੈਚਮੈਂਟ ਸ਼ਾਮਲ ਕਰੋ',
  sendMessage: 'ਸੰਦੇਸ਼ ਭੇਜੋ',
  
  // 思考模式选项
  deepInsight: 'ਡੂੰਘੀ ਸਮਝ · ਸਤਹੀ ਵਿਸ਼ਲੇਸ਼ਣ',
  deepInsightDesc: 'ਮੁੱਖ ਬਿੰਦੂਆਂ ਦੀ ਤੇਜ਼ ਸਮਝ',
  deepExploration: 'ਡੂੰਘੀ ਖੋਜ · ਵਿਆਪਕ ਵਿਸ਼ਲੇਸ਼ਣ',
  deepExplorationDesc: 'ਬਹੁ-ਆਯਾਮੀ ਡੂੰਘੀ ਖੋਜ',
  deepDeconstruction: 'ਡੂੰਘਾ ਵਿਘਟਨ · ਵਿਵਸਥਿਤ ਦਲੀਲ',
  deepDeconstructionDesc: 'ਪਰਤ-ਦਰ-ਪਰਤ ਪ੍ਰਗਤੀਸ਼ੀਲ ਵਿਸ਼ਲੇਸ਼ਣ',
  
  // 写作模式选项
  contractReview: 'ਇਕਰਾਰਨਾਮਾ ਸਮੀਖਿਆ · ਜੋਖਮ ਪਛਾਣ',
  contractReviewDesc: 'ਧਾਰਾ ਵਿਸ਼ਲੇਸ਼ਣ ਅਤੇ ਅਨੁਪਾਲਨ ਜਾਂਚ',
  textPolish: 'ਟੈਕਸਟ ਪਾਲਿਸ਼ · ਪੇਸ਼ੇਵਰ ਪ੍ਰਗਟਾਵਾ',
  textPolishDesc: 'ਭਾਸ਼ਾ ਅਨੁਕੂਲਨ ਅਤੇ ਢਾਂਚਾ ਸਮਾਯੋਜਨ',
  legalDocuments: 'ਕਾਨੂੰਨੀ ਦਸਤਾਵੇਜ਼ · ਮਿਆਰੀ ਡਰਾਫਟਿੰਗ',
  legalDocumentsDesc: 'ਪੇਸ਼ੇਵਰ ਕਾਨੂੰਨੀ ਦਸਤਾਵੇਜ਼ ਲਿਖਣਾ',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'ਲੌਗ ਇਨ',
  register: 'ਰਜਿਸਟਰ',
  welcomeBack: 'LawHelper ਵਿੱਚ ਜੀ ਆਇਆਂ ਨੂੰ',
  loginSubtitle: 'ਤੁਹਾਡਾ AI ਕਾਨੂੰਨੀ ਖੋਜ ਸਹਾਇਕ',
  continueWithGoogle: 'Google ਨਾਲ ਜਾਰੀ ਰੱਖੋ',
  continueWithMicrosoft: 'Microsoft ਨਾਲ ਜਾਰੀ ਰੱਖੋ',
  continueWithWeChat: 'WeChat ਨਾਲ ਜਾਰੀ ਰੱਖੋ',
  orContinueWith: 'ਜਾਂ ਇਸ ਨਾਲ ਜਾਰੀ ਰੱਖੋ',
  emailTab: 'ਈਮੇਲ',
  phoneTab: 'ਫ਼ੋਨ',
  emailPlaceholder: 'ਆਪਣੀ ਈਮੇਲ ਦਰਜ ਕਰੋ',
  phonePlaceholder: 'ਫ਼ੋਨ ਨੰਬਰ ਦਰਜ ਕਰੋ',
  codePlaceholder: '6 ਅੰਕ ਦਾ ਕੋਡ ਦਰਜ ਕਰੋ',
  sending: 'ਭੇਜ ਰਿਹਾ ਹੈ...',
  verifying: 'ਤਸਦੀਕ ਕਰ ਰਿਹਾ ਹੈ...',
  verify: 'ਤਸਦੀਕ ਕਰੋ',
  sendMagicLink: 'ਮੈਜਿਕ ਲਿੰਕ ਭੇਜੋ',
  getVerificationCode: 'ਕੋਡ ਪ੍ਰਾਪਤ ਕਰੋ',
  resendCode: 'ਕੋਡ ਦੁਬਾਰਾ ਭੇਜੋ',
  resendIn: 'ਦੁਬਾਰਾ ਭੇਜੋ',
  magicLinkSent: 'ਮੈਜਿਕ ਲਿੰਕ ਤੁਹਾਡੀ ਈਮੇਲ ਤੇ ਭੇਜੀ ਗਈ',
  magicLinkHint: 'ਅਸੀਂ ਤੁਹਾਡੀ ਈਮੇਲ ਤੇ ਇੱਕ ਸੁਰੱਖਿਅਤ ਲਿੰਕ ਭੇਜਾਂਗੇ',
  otpSent: 'ਤਸਦੀਕ ਕੋਡ ਭੇਜਿਆ ਗਿਆ',
  agreeToTerms: 'ਜਾਰੀ ਰੱਖਣ ਨਾਲ, ਤੁਸੀਂ ਸਹਿਮਤ ਹੋ',
  privacyPolicy: 'ਗੋਪਨੀਯਤਾ ਨੀਤੀ',
  termsOfService: 'ਸੇਵਾ ਦੀਆਂ ਸ਼ਰਤਾਂ',
  and: 'ਅਤੇ',
  privacyTitle: 'ਤੁਹਾਡੀ ਗੋਪਨੀਯਤਾ ਮਹੱਤਵਪੂਰਨ ਹੈ',
  privacyIntro: 'ਸਭ ਤੋਂ ਵਧੀਆ ਅਨੁਭਵ ਦੇਣ ਲਈ ਅਸੀਂ ਕੂਕੀਜ਼ ਅਤੇ ਸਮਾਨ ਤਕਨਾਲੋਜੀ ਵਰਤਦੇ ਹਾਂ।',
  essentialCookies: 'ਜ਼ਰੂਰੀ ਕੂਕੀਜ਼',
  essentialDesc: 'ਵੈੱਬਸਾਈਟ ਕੰਮ ਕਰਨ ਲਈ ਲੋੜੀਂਦੀਆਂ',
  analyticsCookies: 'ਵਿਸ਼ਲੇਸ਼ਣ ਕੂਕੀਜ਼',
  analyticsDesc: 'ਸੇਵਾ ਨੂੰ ਬਿਹਤਰ ਬਣਾਉਣ ਵਿੱਚ ਮਦਦ',
  marketingCookies: 'ਮਾਰਕੀਟਿੰਗ ਕੂਕੀਜ਼',
  marketingDesc: 'ਨਿੱਜੀ ਸਮੱਗਰੀ ਲਈ ਵਰਤੀਆਂ ਜਾਂਦੀਆਂ',
  acceptAll: 'ਸਭ ਸਵੀਕਾਰ ਕਰੋ',
  essentialOnly: 'ਸਿਰਫ਼ ਜ਼ਰੂਰੀ',
  customize: 'ਅਨੁਕੂਲਿਤ ਕਰੋ',
  savePreferences: 'ਤਰਜੀਹਾਂ ਸੁਰੱਖਿਅਤ ਕਰੋ',
  back: 'ਪਿੱਛੇ',
  readPrivacyPolicy: 'ਸਾਡੀ ਗੋਪਨੀਯਤਾ ਨੀਤੀ ਪੜ੍ਹੋ',
  cookiePolicy: 'ਕੂਕੀ ਨੀਤੀ',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI ਸਮੀਖਿਆ',
  aiDraft: 'AI ਡਰਾਫਟ',
  smartAssistant: 'ਟੈਂਪਲੇਟ',

  // 知识库搜索
  enableKnowledgeSearch: 'ਖੋਜ ਸਮਰੱਥ ਕਰੋ',
  knowledgeSearchDesc: 'AI ਤੁਹਾਡੇ ਦਸਤਾਵੇਜ਼ਾਂ ਵਿੱਚ ਖੋਜਦਾ ਹੈ',
  clickToDisable: 'ਅਯੋਗ ਕਰੋ',
  clickToEnable: 'ਸਮਰੱਥ ਕਰੋ',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Close Resources Panel',
  uploading: 'Uploading %{fileName}...',
  processing: 'Processing %{fileName}...',
  uploadSuccess: '✓ %{fileName} uploaded successfully',
  uploadError: '✗ Upload failed: %{error}',
  quickAnswer: 'ਤੇਜ਼ ਜਵਾਬ',
  quickAnswerDesc: 'Fast response for simple questions',
  cancelRequest: 'ਰੱਦ ਕਰੋ',
  library: 'ਲਾਇਬ੍ਰੇਰੀ',
  filterAll: 'ਸਭ',
  filterChat: 'Chats',
  filterReview: 'Review',
  filterDraft: 'Draft',
  filterTemplate: 'Template',
  filterForm: 'Form',
  thinking: 'ਸੋਚ ਰਿਹਾ ਹੈ...',
  thinkingProcess: 'Thinking Process',
  analyzingLegalLogic: 'Analyzing legal logic...',
  lawhelperThinking: 'Lawhelper is thinking...',
  serviceError: 'Service Error',
  uploaded: 'Uploaded',
  settingsGeneral: 'ਆਮ',
  settingsNotifications: 'Notifications',
  settingsAppearance: 'Appearance',
  settingsProfile: 'Profile',
  settingsResponseNotifications: 'Response Notifications',
  settingsResponseNotificationsDesc: 'Get notified when AI finishes a response',
  settingsColorMode: 'Color Mode',
  settingsLight: 'Light',
  settingsDark: 'Dark',
  settingsSystem: 'System',
  about: 'ਬਾਰੇ',
  reviewTitle: 'Document Review',
  exitReview: 'Exit Review',
  uploadPrompt: 'Upload PDF to start review',
  uploadButton: 'Select File',
  startChatConfig: 'Type "Review this document" to start',
  reviewPlaceholder: 'Type a message or "Review this document"...',
  analyzing: 'Reviewing...',
  reviewComplete: 'Review Complete',
  issuesFound: 'Found %{count} issues',
  draftTitle: 'Legal Document Drafting',
  draftPlaceholder: 'Edit here or ask AI to generate...',
  analyzingTemplate: 'Analyzing template file %{name}...',
  templateAnalyzed: '✅ Template %{name} analyzed! Tell me how you want to modify or fill this template.',
  templateAnalysisPrompt: 'Analyze key clauses of this template',
  parsingFailed: '⚠️ Failed to parse file, but you can still describe your needs.',
  generating: 'Generating...',
  generatedSuccess: '✅ Document generated! You can view and edit in the editor.',
  drafterWelcome: 'Welcome to AI Document Assistant',
  drafterYouCan: 'You can:',
  drafterUploadTemplate: 'Upload a template for AI to analyze',
  drafterDescribeNeeds: 'Describe your document requirements',
  drafterLetAiHelp: 'Let AI help you draft contracts, agreements, etc.',
  drafterExamples: 'Examples:',
  drafterExampleRental: '"Help me draft a rental agreement"',
  drafterExampleLabor: '"Fill in the labor contract based on template"',
  drafterInputPlaceholder: 'Describe your document needs...',
  drafterThinking: 'Thinking...',
  drafterHistoryTitle: 'History',
  drafterNoHistory: 'No history yet',
  drafterNewChat: 'New Chat',
  drafterHistory: 'History',
  drafterRemoveAttachment: 'Remove attachment',
  drafterLineHeight: 'Line Height',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export as Word (.docx)',
  drafterExportPdf: 'Export as PDF',
  drafterSave: 'Save Document',
  drafterDownload: 'Download Document',
  drafterUndo: 'Undo',
  drafterRedo: 'Redo',
  drafterBold: 'Bold',
  drafterItalic: 'Italic',
  drafterStrike: 'Strikethrough',
  drafterUnderline: 'Underline',
  drafterHighlight: 'Highlight',
  drafterLink: 'Insert Link',
  drafterAlignLeft: 'Align Left',
  drafterAlignCenter: 'Align Center',
  drafterAlignRight: 'Align Right',
  drafterAlignJustify: 'Justify',
  drafterList: 'List',
  drafterBulletList: 'Bullet List',
  drafterOrderedList: 'Ordered List',
  drafterTaskList: 'Task List',
  drafterOpenResource: 'Open Resources Panel',
  drafterStopGeneration: 'Stop generation',
  drafterAgentMode: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOn: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOff: 'Normal chat mode | Click to switch to Agent mode',
  drafterUploadAttachment: 'Upload attachment',
  drafterExit: 'Exit',
  drafterConfirm: 'Confirm',
  drafterOpenLink: 'Open link',
  drafterDeleteLink: 'Delete link',
  drafterQuote: 'Quote',
  workflowTitle: 'AI Workflow',
  workflowRunning: 'Running...',
  workflowReady: 'Ready',
  workflowCompleted: 'Completed',
  workflowStartFailed: 'Workflow start failed',
  workflowExecutionFailed: 'Workflow execution failed',
  workflowInterrupted: 'Workflow interrupted',
  workflowProcessing: 'Processing...',
  workflowStepsCompleted: 'steps completed',
  workflowStepsTotal: 'Workflow completed (%{count} steps)',
  acceptChanges: 'Accept Changes',
  rejectChanges: 'Reject Changes',
  changesAccepted: 'Changes accepted',
  changesRejected: 'Changes rejected',
  stopWorkflow: 'Stop',
  restartWorkflow: 'Restart',
  startDrafting: 'Start Drafting',
  interrupt: 'Stop',
  documentSubject: 'Document Subject *',
  documentType: 'Document Type',
  jurisdiction: 'Jurisdiction',
  specialRequirements: 'Special Requirements (optional)',
  clickStartDrafting: 'Click "Start Drafting" to begin workflow',
  docTypeContract: 'Contract',
  docTypeAgreement: 'Agreement',
  docTypeNotice: 'Notice',
  docTypeLetter: 'Letter',
  docTypePetition: 'Petition',
  docTypeWill: 'Will',
  docTypePowerOfAttorney: 'Power of Attorney',
  countryChina: 'China',
  countryUSA: 'United States',
  countryGermany: 'Germany',
  countryJapan: 'Japan',
  countryFrance: 'France',
  countryUK: 'United Kingdom',
  citationVerified: 'Verified',
  citationUnverified: 'Unverified',
  imageLoadFailed: 'Image failed to load',
  smartDocTitle: 'ਸਮਾਰਟ ਦਸਤਾਵੇਜ਼ ਸਹਾਇਕ',
  smartDocChatTitle: 'AI Document Assistant',
  smartDocDropPrompt: 'Drop PDF file here',
  smartDocSelectFile: 'Select File',
  smartDocOr: 'or',
  smartDocWelcomeTitle: 'Welcome to AI Document Assistant',
  smartDocWelcomeYouCan: 'You can:',
  smartDocUploadForAI: 'Upload a template for AI to analyze',
  smartDocDescribeDoc: 'Describe your document requirements',
  smartDocLetAIDraft: 'Let AI help you draft contracts, agreements, etc.',
  smartDocExamples: 'Examples:',
  smartDocExampleRental: '"Help me draft a rental agreement"',
  smartDocExampleLabor: '"Fill in the labor contract based on template"',
  smartDocInputPlaceholder: 'Describe your document needs...',
  smartDocRemoveAttachment: 'Remove attachment',
  smartDocOpenResources: 'Open Resources Panel',
  smartDocExit: 'Exit',
  reviewStartFailed: 'Review workflow start failed',
  reviewFailed: 'Review failed',
  reviewFoundIssues: 'Review complete, found %{count} issues.',
  cannotReadStream: 'Cannot read response stream',
  parseEventFailed: 'Failed to parse workflow event',
  errorPrefix: 'ਗਲਤੀ',
  unknownError: 'Unknown error',
  file: 'ਫਾਇਲ',
  loading: 'ਲੋਡ ਹੋ ਰਿਹਾ...',
  localFolders: 'Local Folders',
  selectLocalFolder: 'Select Local Folder',
  reselectFolder: 'Change Folder',
  addToContext: 'Add to Chat',
  saveFile: 'Save',
  renameFile: 'Rename',
  fileSaved: 'File saved successfully',
  fileRenamed: 'File renamed to %{name}',
  browserNotSupported: 'Your browser does not support local folder access',
  noFolderSelected: 'Select a local folder to browse files',
  scanningFolder: 'Scanning folder...',
  selectFileToPreview: 'Select a file to preview',
  aiAnalyze: 'AI ਵਿਸ਼ਲੇਸ਼ਣ',
};
